import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SacSignupComponent } from './components/sac-signup/sac-signup.component';

const routes: Routes = [
  {
    path: '**',
    component: SacSignupComponent,
    data: {
      page_name: 'sac-signup',
      category: 'start fundraiser',
      lastOrderSkip: true
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SacSignupRoutingModule { }
